import { BillingAccount, FeatureTrialStatus, FeatureTrialType, PlanCode } from '@/typings/domain'
import dayjs from 'dayjs'
import { replace } from 'lodash-es'

const ORG_PLAN_CODES = [PlanCode.E10, PlanCode.E20, PlanCode.E30, PlanCode.EnCor]

export default function getBillingAccountPlanInfo(billingAccount: {
  currentFeatureTrialInfo?: Maybe<
    Pick<NonNullable<BillingAccount['currentFeatureTrialInfo']>, 'trialType' | 'status' | 'endDate'>
  >
  planPackage?: Maybe<{ plan: { code: string } }>
}) {
  const trialInfo = billingAccount.currentFeatureTrialInfo
  const isActiveTrial =
    !!trialInfo?.trialType &&
    trialInfo.status === FeatureTrialStatus.InUse &&
    dayjs(trialInfo.endDate).endOf('day').isAfter(dayjs())
  const isOrgPlanActiveTrial = isActiveTrial && trialInfo.trialType === FeatureTrialType.E30Trial
  const isEntPlanActiveTrial = isActiveTrial && trialInfo.trialType === FeatureTrialType.Ent2Trial

  const activeTrialEndDate = isActiveTrial ? trialInfo.endDate : null
  const planPackagePlanCode = billingAccount.planPackage?.plan.code ?? 'free'
  const featureTrialPlanCode = isActiveTrial ? replace(trialInfo.trialType!, '_trial', '') : null
  const isOrgPlan = ORG_PLAN_CODES.includes(planPackagePlanCode as PlanCode)

  return {
    isFreeAccount: planPackagePlanCode === 'free',
    isActiveTrial,
    activeTrialEndDate,
    isOrgPlan,
    isOrgPlanActiveTrial,
    isEntPlanActiveTrial,
    isOrgPlanOrTrial: isOrgPlan || isOrgPlanActiveTrial,
    activePlanCode: featureTrialPlanCode ?? planPackagePlanCode,
  }
}
